// extracted by mini-css-extract-plugin
export default {"modulesSelectContainer":"ModulesSelect_modulesSelectContainer__+1dVi","modulesSelect":"ModulesSelect_modulesSelect__U0ZSL"};